import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormOneColumn', null, { withChildren: true });
